import { TFunction } from 'i18next'

import { NotificationKind } from '@/constants/common'
import { marketPresentation } from '@/config/marketPresentation'
import { formatDateWithDayOfWeek } from '@/utils/formatter'
import { toCurrency } from '@/utils/numbers'

type AppRouter = {
  push: (href: any) => void
}

export function convertNotificationEdge(node: any, t: TFunction<'translation', undefined>, router: AppRouter) {
  const { number, kind, createdAt, payload, status } = node
  // console.log({ node })
  const titleParams = {
    title: payload?.bonusActivityTitle ?? t('notification:newActivityNotification')
  }
  const descriptionParams = {
    orderId: payload?.internalKey,
    payTime: '30',
    amount: toCurrency(payload?.amount?.value, 2),
    amountOut: toCurrency(payload?.relatedAmount?.value, 6),
    token: marketPresentation.platformToken.displayName,
    subOrderId: payload?.childInternalKey,
    id: payload.internalKey?.[0] === 'S' ? payload.childInternalKey : payload?.internalKey,
    description: payload?.bonusActivityDescription ?? t('notification:newActivityNotification')
  }
  // console.log(node)
  const title = t(`notification:title.${kind}`, titleParams)
  const content = t(`notification:description.${kind}`, descriptionParams)
  const currencyKind = payload?.amount?.kind

  let action = () => {
    console.log('noop action')
  }
  const internalKey: string = payload ? payload.internalKey : ''
  const kindNum = Number(NotificationKind[kind])

  switch (kindNum) {
    case NotificationKind.BUY_ORDER_PAIRED:
    case NotificationKind.BUY_ORDER_REQUEST_APPEAL_FROM_SELLER:
    case NotificationKind.SELL_ORDER_COMFIRMED_PAYMENT_PROOF:
    case NotificationKind.SELL_ORDER_CHANGED_AMOUNT:
    case NotificationKind.ADMIN_BUY_ORDER_CANCELED:
      action = () => router.push(`/order/buy/${internalKey}`)
      break
    case NotificationKind.SELL_ORDER_PAIRED:
    case NotificationKind.BUY_ORDER_UPLOAD_PAYMENT_PROOF:
    case NotificationKind.BUY_ORDER_CANCELED:
    case NotificationKind.BUY_ORDER_AGREED_CHANGE_AMOUNT:
    case NotificationKind.BUY_ORDER_DISAGREED_CHANGE_AMOUNT:
    case NotificationKind.ADMIN_APPROVED_PAIR_CANCELED:
    case NotificationKind.BUY_ORDER_REQUEST_APPEAL_FROM_BUYER:
    case NotificationKind.ADMIN_FORCE_CANCELED_SELL_ORDER:
    case NotificationKind.BUYER_BUY_ORDER_FORCE_CANCELED:
      action = () =>
        router.push(
          `/order/sell/${internalKey}${payload?.childInternalKey ? `?childId=${payload?.childInternalKey}` : ''}`
        )
      break
    case NotificationKind.ADMIN_FORCE_CONFIRMED:
    case NotificationKind.ADMIN_FORCE_CHANGED_AMOUNT:
    case NotificationKind.ADMIN_FORCE_CANCELED_PAIR:
    case NotificationKind.ADMIN_REJECTED_PAIR_CANCELED:
    case NotificationKind.ADMIN_FORCE_CANCELED_BUY_ORDER:
    case NotificationKind.SELL_ORDER_REQUEST_PAIR_CANCELED:
      action = () => {
        if (internalKey[0] === 'S') {
          router.push(`/order/sell/${internalKey}?childId=${payload?.childInternalKey}`)
        } else {
          router.push(`/order/buy/${internalKey}`)
        }
      }
      break
    case NotificationKind.USER_RECEIVED_PAYMENT_GATEWAY:
    case NotificationKind.USER_TRANSFERRED_PAYMENT_GATE_WAY:
    case NotificationKind.USER_RECEIVED_PAYOUT:
    case NotificationKind.USER_TRANSFERRED_PAYOUT:
    case NotificationKind.USER_RECEIVED_TRANSFER:
    case NotificationKind.USER_TRANSFERRED_TRANSFER:
    case NotificationKind.USER_RECEIVED_EXCHANGE:
    case NotificationKind.USER_TRANSFERRED_EXCHANGE:
      action = () => router.push(`/(main)/asset/${currencyKind}/${payload?.walletEventId}`)
      break
    case NotificationKind.ADMIN_APPROVE_KYC:
    case NotificationKind.ADMIN_REJECT_KYC:
      action = () => router.push(`/setting/kyc/`)
      break
    case NotificationKind.BONUS_ACTIVITY_CREATED:
      action = () => router.push(`/(main)/activity/${payload?.internalKey}`)
      break
    default:
      console.error(`Unknown notification kind: ${kind}`)
  }

  return {
    id: number,
    title,
    content,
    time: formatDateWithDayOfWeek(createdAt), //convertToDate(new Date(createdAt).valueOf()),
    unread: status === 'UNREAD',
    action
  }
}
